import { createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { LeaseInvoiceSettingRepository } from '~/repositories/settings/leaseInvoiceSettingRepository';
import type { LeaseInvoiceSettings, LeaseInvoiceSettingsCompanyPortalTypedSettingsWithOverridesDocument } from '~/swagger/settings/Api';
export const [LeaseInvoiceSettingsProvider, useLeaseInvoiceSettings] = createMagicDoorContext('LeaseInvoiceSettings', () => {
  const repo = new LeaseInvoiceSettingRepository();

  const [isLoading, setIsLoading] = createSignal<boolean>(false);
  const [error, setError] = createSignal<Error | undefined>(undefined);
  const [allLeaseInvoiceSettings, setAllLeaseInvoiceSettings] = createSignal<
    LeaseInvoiceSettingsCompanyPortalTypedSettingsWithOverridesDocument | undefined
  >();

  const getAllLeaseInvoiceSettings = async () => {
    try {
      setIsLoading(true);
      const json = await repo.getAllLeaseInvoiceSettings();
      setAllLeaseInvoiceSettings(json);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const updateLeaseInvoiceSettings = async (payload: LeaseInvoiceSettings) => {
    try {
      setIsLoading(true);
      await repo.updateLeaseInvoiceSettings(payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const updateOverrideLeaseInvoiceSettings = async (level: string, levelId: string, payload: LeaseInvoiceSettings) => {
    try {
      setIsLoading(true);
      await repo.updateLeaseInvoiceSettingsByLevel(level, levelId, payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const addOverrideSettings = async (level: string, levelId: string, payload: LeaseInvoiceSettings) => {
    try {
      setIsLoading(true);
      await repo.updateLeaseInvoiceSettingsByLevel(level, levelId, payload);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  const removeOverrideSettings = async (level: string, levelId: string) => {
    try {
      setIsLoading(true);
      await repo.deleteLeaseInvoiceSettingsByLevel(level, levelId);
    } catch (err) {
      setError(err instanceof Error ? err : new Error(String(err)));
    } finally {
      setIsLoading(false);
    }
  };

  return {
    error,
    isLoading,
    allLeaseInvoiceSettings,
    getAllLeaseInvoiceSettings,
    updateLeaseInvoiceSettings,
    addOverrideSettings,
    updateOverrideLeaseInvoiceSettings,
    removeOverrideSettings,
  };
});
